






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { ReferenceBasicData as ReferenceBasicDataModel } from '@/models/references/reference-basic-data';
import { ReferenceType } from '@/models/references/reference-type';
import { GenericResult } from '@/models/common/results/generic-result';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { referencesService, authorizationManagerService, notificationsService, usersService } from '@/services';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        ReferenceBasicData: () => import('@/components/references/ReferenceBasicData.vue')
    }
})
export default class NewReference extends Vue {
    @Prop() private referenceType!: ReferenceType;
    private reference: ReferenceBasicDataModel = new ReferenceBasicDataModel({ type: this.referenceType });
    private savingReference: boolean = false;

    private async mounted(): Promise<void> {
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: this.referenceType === ReferenceType.Product ? UserActionEntityType.Products : UserActionEntityType.Services,
                scope: UserActionScopeType.New
            })
        );
    }

    private close(): void {
        this.$router.push(`/${this.referenceType === ReferenceType.Product ? 'products' : 'services'}` + (this.$route.query.businessName ? '?businessName=' + this.$route.query.businessName : ''));
    }

    private async newReference(gotoEditPage: boolean): Promise<void> {
        this.savingReference = true;

        if ((this.$refs.referenceData as any).hasErrors()) {
            this.savingReference = false;
            return;
        }

        try {
            const newReferenceResult: GenericResult = await referencesService.newReference(this.reference);
            if (newReferenceResult.result) {
                notificationsService.showToastSuccessNotification(
                    this.reference.type === ReferenceType.Product
                        ? 'components.references.newReference.newProduct.notification.successMessage'
                        : this.reference.type === ReferenceType.Service
                        ? 'components.references.newReference.newService.notification.successMessage'
                        : this.reference.type === ReferenceType.RentalService
                        ? 'components.references.newReference.newRentalService.notification.successMessage'
                        : 'components.references.newReference.notification.successMessage'
                );
                authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.References, newReferenceResult.id);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: this.referenceType === ReferenceType.Product ? UserActionEntityType.Products : UserActionEntityType.Services,
                        scope: UserActionScopeType.New,
                        entityId: newReferenceResult.id
                    })
                );

                if (gotoEditPage) {
                    this.$router.push({
                        name: 'editProduct',
                        params: { id: newReferenceResult.id.toString() }
                    });
                } else {
                    this.close();
                }

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingReference = false;
        }
    }
}
